import { Injectable } from '@angular/core';

import { DiagStackGenericResponse, DiagStackStructure } from '@vi-iot/client';

import {
  ActiveErrorWithDiagStackDetail,
  BusDetailsWithDtcError,
  DiagStackStructureSemantic,
} from '@store';

@Injectable({
  providedIn: 'root',
})
export class DiagStackDtcService {
  constructor() {}

  dtcStructureExtractor(
    activeDtcResponse: DiagStackGenericResponse
  ): ActiveErrorWithDiagStackDetail[] {
    const errors = activeDtcResponse?.structure?.find(
      (structure) => structure?.severity === 'ERROR'
    )?.structure;
    const finalOutput: ActiveErrorWithDiagStackDetail[] = [];

    if (!!errors?.length) {
      errors.forEach((structure) => {
        this.eachRecursive(structure, finalOutput);
      });
    }

    return finalOutput;
  }

  private getPotentialData(
    structure: DiagStackStructure[],
    outputArray: ActiveErrorWithDiagStackDetail[]
  ): boolean {
    let objectToAdd = {} as ActiveErrorWithDiagStackDetail;

    structure.forEach((element) => {
      if (
        element.semantic === DiagStackStructureSemantic.FAULTREAD &&
        element.valuetranslationid &&
        element.value
      ) {
        objectToAdd.errorCode = element.valuetranslationid;
        objectToAdd.errorName = element.value;
      } else if (element.semantic === DiagStackStructureSemantic.VALUE) {
        objectToAdd.PA_BusAddre = element.value;
      } else if (element.semantic === DiagStackStructureSemantic.ENUM) {
        objectToAdd.PA_BusType = element.value;
      }
    });

    if (objectToAdd.PA_BusAddre && objectToAdd.PA_BusType && objectToAdd.errorCode) {
      outputArray.push(objectToAdd);

      return true;
    }
  }

  private eachRecursive(input: DiagStackStructure, externalArray: BusDetailsWithDtcError[]): void {
    if (
      (input.semantic === '' || input.semantic === DiagStackStructureSemantic.FAULTREAD) &&
      input.structure?.length
    ) {
      // To verify - 2nd nesting is required -> run eachRecursive only if this one condition is not satisfied
      if (!this.getPotentialData(input.structure, externalArray)) {
        input.structure.forEach((structure) => this.eachRecursive(structure, externalArray));
      }
    }
  }
}
